<app-spinner></app-spinner>
<router-outlet></router-outlet>
<app-toast aria-live="polite" aria-atomic="true" class="toast-center"></app-toast>